import React, { Fragment } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import _ from 'lodash';
import logger from '../../logger';

import EditQuestion from '../../components/Surveys/EditQuestion';
import { db } from '../../utils/firebase';
import SearchDialog from '../../components/SearchDialog';
import QSetSearchDialog from '../../components/QSetSearchDialog';
import AlertDialog from '../../components/AlertDialog';
import ErrorDialog from '../../components/ErrorDialog';
import { 
    array_move, 
    isAttributeUnique, 
    checkQuestion, 
    checkLogicArray,
    getWorkspace,
    isResponseOkay
} from '../../utils/miscFunctions';
import QuestionContext from '../../QuestionContext';
import LogicDialog from '../../components/Surveys/LogicDialog';
import ErrorBoundary from '../../components/ErrorBoundary';
import VaultApiRequestService from '../../VaultApiRequestService';
import { withSurveyContext } from '../../SurveyContext';
import ComboBox from '../../components/Autocomplete';

const workspaces = [
    { label: `${process.env.REACT_APP_ACTIVE_WORKSPACE} (Active)`, value: process.env.REACT_APP_ACTIVE_WORKSPACE },
    { label: `${process.env.REACT_APP_ARCHIVED_WORKSPACE} (Archived)`, value: process.env.REACT_APP_ARCHIVED_WORKSPACE },
]

const menuItems = [
    { value: 'new', label: 'Add new question' },
    { value: 'existing', label: 'Add existing question' },
    { value: 'set', label: 'Add question set' },
    { value: 'welcome_screens', label: 'Welcome Screen' },
    { value: 'thankyou_screens', label: 'Thank You Screen' },
]

const languages = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'ru', label: 'Russian' },
    { value: 'ch', label: 'Chinese' },
    { value: 'fr', label: 'French' },
    { value: 'tl', label: 'Tagalog' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'so', label: 'Somali' },
    { value: 'ko', label: 'Korean' }
]

const styles = {
    'form-container': {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '60%',
        marginBottom: 30,
    },
    'label': {
        fontSize: 20,
        marginBottom: 0,
        textTransform: 'capitalize',
        color: '#0256c5',
        paddingLeft: 1 + "rem"
    },
    'input': {
        backgroundColor: 'white',
        border: 'none',
        borderBottom: '2px solid #B8D0EF',
        outline: 'none',
        width: '100%',
        //height: 3+"rem",
        fontSize: 1 + "rem",
        fontWeight: 'regular',
        lineHeight: 1.6,
        marginBottom: 15,
        boxShadow: 'none',
        boxSizing: 'border-box',
        borderRadius: "4px 4px 0 0",
    },
    'button': {
        backgroundColor: '#0256c5',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 8,
        fontSize: 16,
        padding: 10,
        margin: 10,
        width: '70%',
    },
    'select': {
        fontSize: 16,
        width: '50%',
        margin: 3,
        height: 40
    }
}

class EditSurvey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            title: '',
            language: 'en',
            fields: [],
            welcome_screens: null,
            thankyou_screens: [],
            hidden: [],
            logic: [],
            question_sets: [],
            openQuestionSearch: false,
            openQSetSearch: false,
            originalData: null,
            openSnackbar: false,
            snackbarMessage: '',
            openAlert: false,
            alertTitle: '',
            alertText: '',
            openError: false,
            errorTitle: '',
            errorDetails: [],
            alertType: '',
            deleteIdx: null,
            saveIdx: null,
            anchorEl: null,
            currentLogicQuestion: null,
            selectedCampaign: undefined,
            originalCampaign: undefined,
        }
        this.fieldRefs = [];
    }

    getCampaigns() {
        const { surveyContext } = this.props;
        if (surveyContext.customers) {
            const { id } = this.state;
            const customer = surveyContext.customers.find(
                customer => customer.campaigns.some(
                    campaign => 
                {
                    if (campaign.surveys.includes(id)) {
                        this.setState({ selectedCampaign: campaign, originalCampaign: campaign })
                    }
                    return campaign.surveys.includes(id)
                })
            );
            this.setState({ campaigns: customer?.campaigns || [] })
        }
    }

    async componentDidUpdate(prevProps) {
        const { surveyContext } = this.props;
        if (!_.isEqual(surveyContext?.customers, prevProps.surveyContext?.customers)) {
            this.getCampaigns();
        }
    }

    // on page load, set question set listener and pull typeform data for id in url
    async componentDidMount() {
        if (this.state.id) {
            this.getCampaigns();
            db.collection("question_sets").onSnapshot(querySnapshot => {
                const question_sets = querySnapshot.docs.map(doc => doc.data());
                this.setState({
                    question_sets: question_sets
                });
            });
            let data = await fetch(`/.netlify/functions/typeform?type=getSingle&uid=${this.state.id}`).then(response =>
                response.json()
            ).catch(err => console.log(err));
            if (isResponseOkay(data)) {
                this.setState({
                    workspace: getWorkspace(data.message.workspace),
                    title: data.message.title,
                    language: data.message.settings.language,
                    fields: data.message.fields ? data.message.fields : [],
                    settings: data.message.settings,
                    thankyou_screens: data.message.thankyou_screens,
                    welcome_screens: data.message.welcome_screens,
                    hidden: data.message.hidden,
                    logic: data.message.logic ? data.message.logic : [],
                    originalData: _.cloneDeep(data.message),
                    disabledQuestions: data.message.fields ? fillDisabled(data.message.fields.length) : []
                });
            } else {
                if(data){
                    console.log(data.status);
                    console.log(data.message);
                }
                console.log("Error retrieving survey with that ID");
            }
        } else {
            this.props.history.push('/surveys')
        }
    }

    // onChange handler for workspace select
    handleWorkspaceChange = async (event) => {
        const newWorkspace = event.target.value;
        if (newWorkspace === this.state.workspace) return;
        this.handleFormChange(newWorkspace, "workspace");
    }


    toggleQuestionSearch = () => {
        this.setState({
            openQuestionSearch: !this.state.openQuestionSearch
        });
    }

    handleFormChange = (value, field) => {
        this.setState({
            [field]: value
        });
    }

    // adds welcome or thank you screen
    handleAddScreen = (screen) => {
        let dataCopy;
        let newScreen = {
            title: "",
            ref: "",
            properties: {}
        }
        if (screen === 'welcome_screens') {
            if (this.state.welcome_screens) {
                this.setState({
                    snackbarMessage: "Couldn't add welcome screen. Welcome screen already exists...",
                    openSnackbar: true
                })
                return;
            }
            dataCopy = [newScreen];
        } else {
            if (this.state.thankyou_screens.length > 1) {
                this.setState({
                    snackbarMessage: "Couldn't add thank you screen. Thank you screen already exists...",
                    openSnackbar: true
                })
                return;
            }
            dataCopy = [...this.state[screen]];
            dataCopy.unshift(newScreen);
        }
        this.setState({
            [screen]: dataCopy
        });
    }

    // removes welcome or thank you screen
    handleDeleteScreen = (screen) => {
        let dataCopy;
        if (screen === 'welcome_screens') {
            dataCopy = null;
        } else {
            dataCopy = [...this.state[screen]];
            dataCopy.splice(0, 1);
        }
        this.setState({
            [screen]: dataCopy
        });
    }

    // onChange handler for thankyou or welcome screen updates
    handleScreenChange = (value, path, screen, idx) => {
        let dataCopy = [...this.state[screen]];
        _.set(dataCopy[idx], path, value);
        this.setState({
            [screen]: dataCopy
        });
    }

    // appends empty question to survey fields
    addQuestion = () => {
        let dataCopy = [...this.state.fields];
        dataCopy.push({
            title: '',
            ref: '',
            type: 'yes_no',
            validations: { required: true },
            properties: {}
        });
        let newDisabled = [...this.state.disabledQuestions, false];
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled
        });
    }

    // open Delete Question alert and give alert message
    handleDelete = (idx) => {
        this.setState({
            openAlert: true,
            alertTitle: 'Delete this question?',
            alertText: 'This action can not be done. Are you sure you want to delete this question?',
            alertType: 'deleteQuestion',
            deleteIdx: idx
        })
    }

    // removes question from survey fields array at given index
    deleteQuestion = (idx) => {
        let dataCopy = [...this.state.fields];
        dataCopy.splice(idx, 1);
        let newDisabled = [...this.state.disabledQuestions];
        newDisabled.splice(idx, 1);
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled
        });
    }

    // moves survey field from oldIdx to newIdx
    handleFieldPositionChange = (oldIdx, newIdx) => {
        let newFields = array_move(this.state.fields, oldIdx, newIdx);
        let newDisabled = array_move(this.state.disabledQuestions, oldIdx, newIdx);
        this.setState({
            fields: newFields,
            disabledQuestions: newDisabled
        });
    }

    // on question search click, clone question data and append question to survey fields array
    onRowClick = (data) => {
        let dataCopy = [...this.state.fields];
        let clonedData = _.cloneDeep(data);
        let newQuestion = {
            title: clonedData.title,
            ref: clonedData.ref,
            type: clonedData.type,
            properties: clonedData.properties
        }
        if (data.type !== 'group' && data.type !== 'statement') {
            newQuestion.validations = { required: true }
        } 
        if (data.type === 'multiple_choice') {
            newQuestion.properties.choices = newQuestion.properties.choices.map(choice => {
                return { label: choice.label }
            })
        }
        dataCopy.push(newQuestion);
        let newDisabled = [...this.state.disabledQuestions, true];
        this.setState({
            fields: dataCopy,
            disabledQuestions: newDisabled,
            openQuestionSearch: false,
        });
    }

    // checks if updates have been made and opens alert dialog
    handleUpdate = () => {
        let editing = this.state.disabledQuestions.find(q => q === false);
        let changedFields = this.checkDifferences();
        if (editing !== undefined) {
            this.setState({
                snackbarMessage: "Save or cancel all edits before updating the survey.",
                openSnackbar: true
            })
        } else if (changedFields.length === 0) {
            this.setState({
                snackbarMessage: 'Survey not updated: no fields were changed.',
                openSnackbar: true
            })
        } else {
            let alertText = "The following fields have been changed: ";
            changedFields.forEach((field, idx) => {
                if (idx !== changedFields.length - 1) {
                    alertText = alertText + field + ', '
                } else {
                    alertText = alertText + field
                }
            })
            this.setState({
                openAlert: true,
                alertTitle: "Are you sure you want to update this survey?",
                alertText: alertText,
                alertType: 'update'
            })
        }
    }

    // returns array with survey attributes that have been updated
    checkDifferences = () => {
        const { title, language, fields, welcome_screens, thankyou_screens, logic, originalData, workspace, selectedCampaign, originalCampaign } = this.state;
        let diff = [];
        if (title !== originalData.title) {
            diff.push("Title");
        }
        if (workspace !== getWorkspace(originalData.workspace)) {
            diff.push("Workspace");
        }
        if (language !== originalData.settings.language) {
            diff.push("Language");
        }
        if (!_.isEqual(fields, originalData.fields)) {
            diff.push("Fields");
        }
        if (!_.isEqual(welcome_screens, originalData.welcome_screens)) {
            diff.push("Welcome screen");
        }
        if (!_.isEqual(thankyou_screens, originalData.thankyou_screens)) {
            diff.push("Thank you screen");
        }
        if (!(!originalData.logic && logic.length === 0) && !_.isEqual(logic, originalData.logic)) {
            diff.push("Logic");
        }
        if (selectedCampaign !== originalCampaign) {
            diff.push("selectedCampaign");
        }
        return diff;
    }

    updateSurveyInVault = async (typeFormResponse, campaign) => {
        try {
            const { surveyContext } = this.props;
            let payload = _.pick(typeFormResponse.message, ['id', 'workspace', 'settings.language', 'title']);
            if (payload.workspace) {
                payload.workspace = getWorkspace(payload.workspace);
            }
            if (_.get(payload, 'settings.language')) {
                payload.language = payload.settings.language;
                payload = _.omit(payload, 'settings');
            }
            if (payload.title) {
                payload.name = payload.title;
                payload = _.omit(payload, 'title');
            }
            if (campaign) {
                payload.campaign = campaign.id
            }
            const vaultResponse = await VaultApiRequestService.editSurvey(payload);
            if (!vaultResponse?.data) {
                logger.exception(
                    'Error updating survey in Vault',
                    _.get(vaultResponse, 'message'),
                    { payload }
                );
                this.setState({
                    snackbarMessage: 'Error updating survey in Vault',
                    openSnackbar: true
                });
            } else {
                surveyContext.fetchAndUpdateCustomers();
                this.setState({
                    snackbarMessage: 'Survey successfully updated!',
                    openSnackbar: true
                });
                this.props.history.push(`/surveys/${this.state.id}`);
            }
        } catch (err) {
            logger.error(err, { action: 'Update survey in vault' });
            this.setState({
                snackbarMessage: 'Error updating survey record in Vault',
                openSnackbar: true
            });
        }
    }

    // send update request via typeform API with new survey data
    updateSurvey = async() => {
        let isRefUnique = isAttributeUnique(this.state.fields, 'ref');
        if (!isRefUnique) {
            this.setState({
                snackbarMessage: "Error updating survey: multiple fields with the same ref.",
                openSnackbar: true
            })
            return;
        }
        let data = {
            ...this.state.originalData,
            fields: this.state.fields,
            title: this.state.title,
            workspace: { href: `https://api.typeform.com/workspaces/${this.state.workspace}` },
            settings: {
                ...this.state.originalData.settings,
                language: this.state.language
            }
        }
        if (this.state.welcome_screens) {
            data.welcome_screens = this.state.welcome_screens;
        }
        if (this.state.thankyou_screens) {
            data.thankyou_screens = this.state.thankyou_screens;
        }
        if (this.state.logic.length > 0) {
            let allFields = [...this.state.fields];
            if (this.state.welcome_screens) {
                allFields = allFields.concat(this.state.welcome_screens);
            }
            if (this.state.thankyou_screens) {
                allFields = allFields.concat(this.state.thankyou_screens);
            }
            data.logic = checkLogicArray(this.state.logic, allFields);
        }
        let body = {
            body: JSON.stringify(data),
            method: 'POST'
        }
        let resp = await fetch(`/.netlify/functions/typeform?type=update&uid=${this.state.id}`, body).then(response =>
            response.json()
        ).catch(err => {
            logger.error(err, { 
                action: 'CUpdate survey in Typeform',
                payload: data, 
                survey: this.state.id 
            });
        });
        if (isResponseOkay(resp)) {
            const campaignToUpdate = this.state.selectedCampaign !== this.state.originalCampaign && this.state.selectedCampaign;
            await this.updateSurveyInVault(resp, campaignToUpdate);
        } else if (resp) {
            logger.exception(
                'Error updating survey in Typeform',
                '',
                { 
                    survey: this.state.id,
                    description: _.get(resp, 'message.description'),
                    details: _.get(resp, 'message.details'),
                    payload: data,
                }
            );
            this.setState({
                errorTitle: `${resp.status}: ${resp.message.description}`,
                errorDetails: resp.message.details ? resp.message.details : [],
                openError: true
            })
        } else {
            logger.exception(
                'Error updating survey in Typeform',
                '',
                { survey: this.state.id, payload: data }
            );
            this.setState({
                snackbarMessage: `Error updating survey: netlify function issue`,
                openSnackbar: true
            });
        }
    };

    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        });
    }

    toggleAlert = () => {
        this.setState({
            openAlert: !this.state.openAlert
        });
    }

    toggleError = () => {
        this.setState({
            openError: !this.state.openError
        });
    }

    handleAlertYes = () => {
        if (this.state.alertType === 'deleteQuestion') {
            this.deleteQuestion(this.state.deleteIdx)
        } else if (this.state.alertType === 'update') {
            this.updateSurvey();
        } else if (this.state.alertType === 'saveNewQuestion') {
            this.handleSaveNewQuestion();
        } else {
            console.log("Alert type does not exist.")
        }
        this.setState({
            alertType: '',
            openAlert: false,
            alertText: '',
            alertTitle: '',
        })
    }

    toggleQSetSearch = () => {
        this.setState({
            openQSetSearch: !this.state.openQSetSearch
        });
    }

    // on question set search click, add all fields from question set to survey that exist in current language
    onQSetClick = (data) => {
        console.log("Adding question set: ", data);
        let newQuestions = [];
        let notFoundRefs = [];
        const questions = this.context;
        const newRefs = data.fields;
        const newDisabled = [...this.state.disabledQuestions];
        newRefs.forEach(ref => {
            let found_question = questions.find(q => q.ref === ref && q.language === this.state.language);
            if (found_question) {
                let clonedFound = _.cloneDeep(found_question);
                let newQuestion = {
                    title: clonedFound.title,
                    ref: clonedFound.ref,
                    type: clonedFound.type,
                    properties: clonedFound.properties
                }
                if (found_question.type !== 'group') {
                    newQuestion.validations = { required: true }
                } 
                if (found_question.type === 'multiple_choice') {
                    newQuestion.properties.choices = newQuestion.properties.choices.map(choice => {
                        return { label: choice.label }
                    });
                }
                newQuestions.push(newQuestion);
                newDisabled.push(true);
            } else {
                notFoundRefs.push(ref);
            }
        });
        if (newQuestions.length > 0) {
            let dataCopy = [...this.state.fields, ...newQuestions];
            this.setState({
                fields: dataCopy,
                disabledQuestions: newDisabled
            });
        }
        if (notFoundRefs.length > 0) {
            let alertText = "The following questions were not found in this survey's language: ";
            notFoundRefs.forEach((ref, idx) => {
                if (idx !== notFoundRefs.length - 1) {
                    alertText = alertText + ref + ', ';
                } else {
                    alertText = alertText + ref;
                }
            });
            this.setState({
                openAlert: true,
                alertTitle: "Some questions were not found",
                alertText: alertText,
                alertType: 'question_set'
            })
        }
        this.setState({
            openQSetSearch: false
        });
    }

    // adds new question, existing question, screen, or question set depending on menu click
    handleMenuClick = (option) => {
        if (option === 'new') {
            this.addQuestion();
        } else if (option === 'existing') {
            this.toggleQuestionSearch();
        } else if (option === 'thankyou_screens' || option === 'welcome_screens') {
            this.handleAddScreen(option);
        } else if (option === 'set') {
            this.toggleQSetSearch();
        }
        this.setState({
            anchorEl: null
        })
    }

    toggleDisabled = (idx) => {
        let dataCopy = [...this.state.disabledQuestions];
        dataCopy[idx] = !this.state.disabledQuestions[idx];
        this.setState({
            disabledQuestions: dataCopy
        });
    }

    scrollToQuestion = (idx) => {
        window.scrollTo(0, this.fieldRefs[idx].offsetTop);
    }

    // checks if question has been updated and saves updates 
    handleSaveEdits = (idx, value) => {
        let dataCopy = [...this.state.fields];
        if (!checkQuestion(value, this.context, this.state.language)) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Data for  ${idx + 1}. ${value.ref} does not match database. Change the ref if you would like to save the edits. Press the undo button to cancel edits.`
            })
            return;
        } else if (_.isEqual(dataCopy[idx], value)) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `No changes were made to question ${idx + 1}. ${value.ref}.`
            });
        } else {
            dataCopy[idx] = value;
            this.setState({
                fields: dataCopy,
                openSnackbar: true,
                snackbarMessage: `Successfully edited question ${idx + 1}. ${value.ref}.`
            });
        }
        this.toggleDisabled(idx);
    }

    // add jump to logic jump array for a given field
    addLogicJump = (logicIdx, type, fieldRef) => {
        let dataCopy = [...this.state.logic];
        let newAction = {
            action: "jump",
            details: {
                to: {
                    type: "thankyou",
                    value: "default_tys"
                }
            },
            condition: {
                op: "is",
                vars: [
                    { type: 'field', value: fieldRef },
                ]
            }
        }
        if (type === 'multiple_choice') {
            newAction.condition.vars.push({ type: 'choice', value: null });
        } else if (type === 'yes_no') {
            newAction.condition.vars.push({ type: 'constant', value: true });
        }
        if (logicIdx === -1) {
            let newLogic = {
                type: "field",
                ref: fieldRef,
                actions: [newAction]
            }
            dataCopy.push(newLogic);
        } else if (dataCopy[logicIdx].actions.some(action => action.condition.op === 'always')) {
            dataCopy[logicIdx].actions.splice(-2, 0, newAction);
        } else {
            dataCopy[logicIdx].actions.push(newAction);
        }
        this.setState({
            logic: dataCopy
        })
    }

    // removes logic jump
    handleDeleteLogic = (logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions.splice(idx, 1);
        if (dataCopy[logicIdx].actions.length === 0) {
            dataCopy.splice(logicIdx, 0);
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicJumpTo = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].details.to.value = value;
        const thankyou = this.state.thankyou_screens.some((e) => e.ref === value);
        if (thankyou) {
            dataCopy[logicIdx].actions[idx].details.to.type = "thankyou";
        } else {
            dataCopy[logicIdx].actions[idx].details.to.type = "field";
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicYesNo = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].condition.vars[1] = {
            type: 'constant',
            value: value
        }
        this.setState({
            logic: dataCopy
        })
    }

    setLogicChoice = (choiceIdx, field, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        let choice = field.properties.choices[choiceIdx];
        let choiceRef = choice.ref;
        if (!choiceRef) {
            let fieldCopy = [...this.state.fields];
            choiceRef = `${field.ref}_${choiceIdx}`;
            fieldCopy[this.state.currentLogicQuestion].properties.choices[choiceIdx].ref = choiceRef;
            this.setState({
                fields: fieldCopy
            });
        }
        dataCopy[logicIdx].actions[idx].condition.vars[1] = {
            type: 'choice',
            value: choiceRef
        }
        this.setState({
            logic: dataCopy
        });
    }

    setLogicOp = (value, logicIdx, idx) => {
        let dataCopy = [...this.state.logic];
        dataCopy[logicIdx].actions[idx].condition.op = value;
        this.setState({
            logic: dataCopy
        });
    }

    addLogicAlwaysJump = (value, logicIdx) => {
        let dataCopy = [...this.state.logic];
        const alwaysAction = {
            action: "jump",
            condition: {
                op: "always",
                vars: []
            },
            details: {
                to: {
                    type: "field",
                    value: value
                }
            }
        }
        const thankyou = this.state.thankyou_screens.some((e) => e.ref === value);
        if (thankyou) {
            alwaysAction.details.to.type = "thankyou";
        };
        dataCopy[logicIdx].actions.push(alwaysAction);
        this.setState({
            logic: dataCopy
        });
    }

    toggleSaveAlert = (idx) => {
        const alertText = 'This question does not yet exist in the database. After saving, You will be able to view this question on the question page, add the question to surveys, and archive the question if needed.';
        this.setState({
            openAlert: true,
            alertTitle: 'Save this question to the question store?',
            alertText: alertText,
            alertType: 'saveNewQuestion',
            saveIdx: idx
        })
    }

    // saves question data from a survey field to the question_store collection
    handleSaveNewQuestion = () => {
        const { fields, saveIdx, language } = this.state;
        if (saveIdx == null) {
            console.log("Invalid index: ", saveIdx);
            return;
        }
        const field = { ...fields[saveIdx] };
        var newQuestionRef = db.collection('question_store').doc();
        let newQuestionData = {
            id: newQuestionRef.id,
            title: field.title,
            ref: field.ref,
            type: field.type,
            properties: field.properties,
            language: language,
            dateAdded: new Date(),
            display: true,
            StringMap: []
        }
        if (field.type === 'multiple_choice') {
            newQuestionData.properties.choices = newQuestionData.properties.choices.map(choice => {
                return { label: choice.label }
            });
        }
        newQuestionRef.set(newQuestionData).then(() => {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Question ${newQuestionData.ref} was successfully added to the database.`,
                openAlert: false,
                alertTitle: '',
                alertText: '',
                alertType: '',
                saveIdx: null
            });
        }).catch(err => {
            console.log("Error adding doc: ", err);
            this.setState({
                openSnackbar: true,
                snackbarMessage: `There was an error adding question ${newQuestionData.ref} to the database.`,
                openAlert: false,
                alertTitle: '',
                alertText: '',
                alertType: '',
                saveIdx: null
            });
        })
    }

    // saves question data from a question group survey field to the question_store collection
    handleSaveGroupQuestion = (data) => {
        const { language } = this.state;
        const field = {...data}
        var newQuestionRef = db.collection('question_store').doc();
        let newQuestionData = {
            id: newQuestionRef.id,
            title: field.title,
            ref: field.ref,
            type: field.type,
            properties: field.properties,
            language: language,
            dateAdded: new Date(),
            display: true,
            StringMap: []
        }
        if (field.type === 'multiple_choice') {
            newQuestionData.properties.choices = newQuestionData.properties.choices.map(choice => {
                return { label: choice.label }
            });
        }
        newQuestionRef.set(newQuestionData).then(() => {
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Question ${newQuestionData.ref} was successfully added to the database.`,
            });
        }).catch(err => {
            console.log("Error adding doc: ", err);
            this.setState({
                openSnackbar: true,
                snackbarMessage: `There was an error adding question ${newQuestionData.ref} to the database.`,
            });
        })
    }

    render() {
        const { workspace, selectedCampaign, campaigns } = this.state;
        let openLogic = (this.state.currentLogicQuestion !== null) ? true : false;
        return (
            <div style={{ width: '100%', position: 'relative' }}>
                <h2 style={{ textAlign: 'center' }}> Survey Editor </h2>
                <Button style={{ position: 'absolute', left: 10, top: 0, margin: 0 }} color="secondary" variant='outlined' onClick={() => this.props.history.goBack()}> Back</Button>
                <hr />
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '25%', height: '100vh', overflow: 'scroll', top: 0, position: 'sticky', padding: 10 }}>
                        <h3>Survey Overview</h3>
                        <hr />
                        <h3> {`Typeform ID: ${this.state.id}`} </h3>
                        <InputLabel>Workspace ID</InputLabel>
                        {workspace && 
                            <Select value={workspace} onChange={this.handleWorkspaceChange}>
                                {workspaces.map(workspace => (
                                    <MenuItem value={workspace.value} id={workspace.value} key={workspace.value}> {workspace.label} </MenuItem>
                                ))}
                                {!isKnownWorkspace(workspace) &&
                                    <MenuItem value={workspace}> {`${workspace} (Other)`} </MenuItem>
                                }
                            </Select>
                        }
                        {this.state.hidden &&
                            <Fragment>
                                <h3> Hidden Fields: </h3>
                                {this.state.hidden.map(hiddenField => (
                                    <p key={hiddenField} style={{ margin: 2 }}>{hiddenField}</p>
                                ))}
                            </Fragment>
                        }
                        <h3> Fields: </h3>
                        <ol style={{paddingLeft: 20, paddingRight: 20}}>
                            {this.state.fields.map((field, idx) => (
                                <li key={idx} style={{ cursor: 'pointer', margin: 10 }} onClick={() => this.scrollToQuestion(idx)}>
                                    {field.ref}
                                    {field.type === 'group' &&
                                        field.properties.fields &&
                                        <ol type="a" style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10 }}>
                                            {field.properties.fields.map((field, fieldIdx) => (
                                                <li key={fieldIdx} style={{ marginBottom: 8 }}> {field.ref} </li>
                                            ))}
                                        </ol>
                                    }
                                </li>
                            ))}
                        </ol>
                    </div>
                    <div style={styles['form-container']}>
                        <label style={styles["label"]} htmlFor="title">title</label>
                        <input
                            id="title"
                            type="text"
                            value={this.state.title}
                            onChange={(e) => this.handleFormChange(e.target.value, "title")}
                            required
                            style={styles["input"]}
                            autoComplete="off"
                        />
                        <label style={styles["label"]} htmlFor="language">Language</label>
                        <select id="language" value={this.state.language} onChange={(e) => this.handleFormChange(e.target.value, "language")} style={styles["select"]}>
                            {languages.map(language => {
                                return (
                                    <option key={language.value} value={language.value}> {language.label} </option>
                                )
                            })}
                        </select>
                        {!_.isUndefined(selectedCampaign) && 
                            <ComboBox
                                initialValue={selectedCampaign}
                                options={campaigns}
                                title="Campaign"
                                handleOnChange={(campaign) => this.handleFormChange(campaign, "selectedCampaign")}
                            />
                        }
                        {this.state.welcome_screens &&
                            <div style={{ width: '80%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                <IconButton style={{ position: 'absolute', right: 20 }} onClick={() => this.handleDeleteScreen("welcome_screens")}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                <h4>Welcome Screen</h4>
                                <label style={styles["label"]} htmlFor="welcome-title">Welcome Screen Text </label>
                                <input
                                    id="welcome-title"
                                    style={styles["input"]}
                                    value={this.state.welcome_screens[0]["title"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'title', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="welcome-ref">Welcome Screen Ref </label>
                                <input
                                    id="welcome-ref"
                                    style={styles["input"]}
                                    value={this.state.welcome_screens[0]["ref"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'ref', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="welcome-desc">Welcome Screen Description</label>
                                <input
                                    id="welcome-desc"
                                    style={styles["input"]}
                                    value={this.state.welcome_screens[0]['properties']["description"] ? this.state.welcome_screens[0]['properties']["description"] : ''}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'properties.description', 'welcome_screens', 0)}
                                    autoComplete="off"
                                />
                            </div>
                        }
                        {this.state.fields.map((field, idx) => {
                            return (
                                <div style={{ width: '100%' }} key={idx} ref={fieldRef => this.fieldRefs[idx] = fieldRef}>
                                    <ErrorBoundary>
                                        <EditQuestion
                                            field={field}
                                            idx={idx}
                                            deleteQuestion={this.handleDelete}
                                            handleFieldPositionChange={this.handleFieldPositionChange}
                                            isGroupItem={false}
                                            label={`${idx + 1}.`}
                                            fields={this.state.fields}
                                            disabled={this.state.disabledQuestions[idx]}
                                            toggleDisabled={this.toggleDisabled}
                                            handleSaveEdits={this.handleSaveEdits}
                                            language={this.state.language}
                                            handleFormChange={this.handleFormChange}
                                            logic={this.state.logic}
                                            toggleSaveAlert={this.toggleSaveAlert}
                                            editPage={true}
                                            handleSaveGroupQuestion={this.handleSaveGroupQuestion}
                                        />
                                    </ErrorBoundary>
                                    <hr />
                                </div>
                            )
                        })}
                        {this.state.thankyou_screens.length > 1 &&
                            <div style={{ width: '80%', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                                <IconButton style={{ position: 'absolute', right: 20 }} onClick={() => this.handleDeleteScreen("thankyou_screens")}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                                <h4>Thank You Screen</h4>
                                <label style={styles["label"]} htmlFor="thankyou-title">Thank You Screen Text </label>
                                <input
                                    id="thankyou-title"
                                    style={styles["input"]}
                                    value={this.state.thankyou_screens[0]["title"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'title', 'thankyou_screens', 0)}
                                    autoComplete="off"
                                />
                                <label style={styles["label"]} htmlFor="thankyou-ref">Thank You Screen Ref </label>
                                <input
                                    id="thankyou-ref"
                                    style={styles["input"]}
                                    value={this.state.thankyou_screens[0]["ref"]}
                                    onChange={(e) => this.handleScreenChange(e.target.value, 'ref', 'thankyou_screens', 0)}
                                    autoComplete="off"
                                />
                            </div>
                        }
                        <button style={{ ...styles['button'], backgroundColor: '#f0a34e', fontSize: 14, width: '40%' }}
                            aria-controls="new-question-menu" aria-haspopup="true"
                            onClick={(e) => this.handleFormChange(e.currentTarget, 'anchorEl')}
                        >
                            Add New Field </button>
                        <Menu
                            id="new-question-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={Boolean(this.state.anchorEl)}
                            onClose={() => this.handleFormChange(null, 'anchorEl')}
                            style={{ zIndex: 10 }}
                        >
                            {menuItems.map((option) => (
                                <MenuItem
                                    key={option.value}
                                    onClick={(event) => this.handleMenuClick(option.value)}
                                >
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Menu>
                        <button style={styles["button"]} onClick={this.handleUpdate}> Update Survey </button>
                    </div>
                </div>
                {this.context &&
                    <SearchDialog
                        data={this.context}
                        open={this.state.openQuestionSearch}
                        toggleOpen={this.toggleQuestionSearch}
                        onRowClick={this.onRowClick}
                        languageFilter={this.state.language}
                    />
                }
                {this.state.question_sets &&
                    <QSetSearchDialog
                        data={this.state.question_sets}
                        open={this.state.openQSetSearch}
                        toggleOpen={this.toggleQSetSearch}
                        onRowClick={this.onQSetClick}
                    />
                }
                {(this.state.currentLogicQuestion !== null) &&
                    <LogicDialog
                        open={openLogic}
                        toggleOpen={() => this.handleFormChange(null, "currentLogicQuestion")}
                        logic={this.state.logic}
                        field={this.state.fields[this.state.currentLogicQuestion]}
                        fields={this.state.fields}
                        welcome_screens={this.state.welcome_screens}
                        thankyou_screens={this.state.thankyou_screens}
                        position={this.state.currentLogicQuestion}
                        handleDelete={this.handleDeleteLogic}
                        setChoice={this.setLogicChoice}
                        setYesNo={this.setLogicYesNo}
                        setOp={this.setLogicOp}
                        setJumpTo={this.setLogicJumpTo}
                        addLogicJump={this.addLogicJump}
                        addAlwaysJump={this.addLogicAlwaysJump}
                    />
                }

                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.openSnackbar}
                    autoHideDuration={5000}
                    onClose={this.toggleSnackbar}
                    message={this.state.snackbarMessage}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={this.toggleSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    style={{ fontSize: 14 }}
                />
                <AlertDialog
                    open={this.state.openAlert}
                    title={this.state.alertTitle}
                    text={this.state.alertText}
                    noClick={this.toggleAlert}
                    yesClick={this.state.alertType === 'question_set' ? null : this.handleAlertYes}
                />
                <ErrorDialog 
                    open={this.state.openError}
                    title={this.state.errorTitle}
                    details={this.state.errorDetails}
                    noClick={this.toggleError}
                />
            </div>
        )
    }
};

EditSurvey.contextType = QuestionContext;

function fillDisabled(length) {
    let disabled = [];
    let i;
    for (i = 0; i < length; i++) {
        disabled.push(true);
    }
    return disabled;
}

function isKnownWorkspace(workspaceId) {
    if (!workspaceId) return false;
    if (workspaces.some(workspace => workspace.value === workspaceId)) return true;
    return false;
}

export default withSurveyContext(EditSurvey);
